'use client';

/**
 * TEMPORARY promo popup for the latest drum cover.
 *
 * To swap in a new cover: update VIDEO_URL, STORAGE_KEY (so returning
 * visitors see the new one), the thumbnail and the title/description below.
 *
 * To remove when the campaign is over:
 *   1. Delete the <CoverPromoPopup /> line in src/app/layout.tsx
 *   2. Delete this file
 *
 * Shows once per browser session (sessionStorage gate), ~2s after load.
 */

import React, { useState, useEffect } from 'react';

const VIDEO_URL = 'https://www.youtube.com/watch?v=DD8ytDySm9U';
const STORAGE_KEY = 'dg_counterparts_promo_seen';

export default function CoverPromoPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="New drum cover announcement"
      onClick={dismiss}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        background: 'rgba(0,0,0,0.75)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        animation: 'page-fade 0.35s ease both',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '460px',
          width: '100%',
          background: '#111111',
          border: '1px solid #ff1a1a',
          boxShadow: '0 0 60px rgba(255,26,26,0.25)',
          position: 'relative',
        }}
      >
        <button
          onClick={dismiss}
          aria-label="Close"
          style={{
            position: 'absolute',
            top: '10px',
            right: '12px',
            background: 'none',
            border: 'none',
            color: '#cccccc',
            fontSize: '1.2rem',
            cursor: 'pointer',
            lineHeight: 1,
            zIndex: 1,
          }}
        >
          ✕
        </button>

        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/assets/images/counterparts-cover-thumb.jpg"
          alt="A Martyr Left Alive by Counterparts — full drum cover by Diggity Glover"
          style={{
            width: '100%',
            aspectRatio: '16/9',
            objectFit: 'cover',
            display: 'block',
            borderBottom: '1px solid rgba(255,26,26,0.3)',
            filter: 'grayscale(30%)',
          }}
        />

        <div style={{ padding: '24px' }}>
          <p
            style={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '0.65rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: '#ff1a1a',
              marginBottom: '10px',
            }}
          >
            // New Drum Cover
          </p>
          <h3
            style={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 900,
              textTransform: 'uppercase',
              fontSize: '1.4rem',
              lineHeight: 1.1,
              color: '#ffffff',
              marginBottom: '10px',
            }}
          >
            Counterparts — A Martyr Left Alive
          </h3>
          <p
            style={{
              fontFamily: 'Manrope, sans-serif',
              fontSize: '0.9rem',
              lineHeight: 1.6,
              color: '#cccccc',
              marginBottom: '20px',
            }}
          >
            New full-length drum cover, out now on YouTube. Filmed at MT Drum Studio —
            every hit, live on camera.
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <a
              href={VIDEO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ fontSize: '0.8rem', padding: '10px 22px' }}
              onClick={dismiss}
            >
              Watch Now
            </a>
            <button
              onClick={dismiss}
              className="btn-outline"
              style={{ fontSize: '0.8rem', padding: '10px 22px', cursor: 'pointer' }}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
